"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiVersion = void 0;
class ApiVersion {
}
exports.ApiVersion = ApiVersion;
//# sourceMappingURL=api-version.js.map